<template>
  <div class="form-registro">
    <main class="container registro p-5">
        <img class="mb-4 mx-auto d-block" src="@/assets/img/logo-vertical.png" alt="" width="250">
        <h1 class="titulo-r text-center">Olvidé mi contraseña</h1>
        <p class="text-center texto-r">Ingresa tu correo para recuperar <br> tu contraseña </p>
        <form @submit.prevent="submit" class="d-flex justify-content-center p-2">
                <div class="col-sm-6">
                  <label for="Correo" class="form-label">Correo electrónico *</label>
                  <input type="email" class="form-control" id="Correo" placeholder="name@example.com" v-model="recoverForm.Correo">
                  <button class="w-100 btn btn-lg btn btn-registro m-t" type="submit">Recuperar contraseña </button>
                </div> 
        </form>
    </main>
</div>
</template>

<script>

import helpers from '@/services/helpers'
import auth from '@/services/auth'

export default {
  name: "Login",
  data() {
    return {
      recoverForm: {
        Correo: "",
      },
      deshabilitado: true,
    };
  },

  mounted() {
    helpers.habilitarBoton(this);
  },
  methods: {
    async submit(e) {
      
      let _this = this;
      //helpers.deshabilitarBoton(this);
     
      if (
        _this.recoverForm.Correo.length < 5 
      ) {
        toastr["error"]("Ingrese un correo válido");
        return;
      }
      //login
      if (await auth.recover(this)){
        //console.log("ENVIO CORRECTO");
      }
      else{
        //console.log("ERROR AL ENVIAR CODIGO DE VALIDACIÓN");
      }
      helpers.habilitarBoton(this, 4);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/auth/RecuperarContraseña.vue